<template>
<v-app>
  <NewsPopup />
  <v-app-bar 
    app
    dark
    color="#139393"
  >
    <v-app-bar-nav-icon class="d-flex d-sm-none" @click.stop="shown = !shown"></v-app-bar-nav-icon>
    <v-app-bar-nav-icon class="d-none d-sm-flex" @click.stop="minimised = !minimised"></v-app-bar-nav-icon>
    <SiteLogo></SiteLogo>
    <v-spacer></v-spacer>
    <!-- <v-btn
      :to="{'name':'PageMainHome'}"
      text
      class="mr-1 d-none d-sm-flex"
    >
      <span>Home</span>
    </v-btn> -->
  </v-app-bar>
  <v-navigation-drawer 
    app
    v-model="shown"
    :mobile-breakpoint="600"
    class="d-flex d-sm-none"
  >
    <Menu></Menu>
  </v-navigation-drawer>
  <v-navigation-drawer 
    app
    :mini-variant="minimised"
    :mobile-breakpoint="600"
    class="d-none d-sm-flex"
  >
    <Menu></Menu>
  </v-navigation-drawer>
  <v-main>
    <router-view :key="$route.fullPath"/>
  </v-main>
   <Footer></Footer>
</v-app>
</template>

<script>
  import Menu from '@/components/Menu'
  import SiteLogo from '@/components/SiteLogo'
  import Footer from "@/components/Footer";
  import NewsPopup from '@/components/NewsPopup';
  import { mapState } from "vuex";
  export default {
    components:{
      Menu,
      SiteLogo,
      Footer,
      NewsPopup
    },
    data: () => ({
      shown: false,
      minimised:false,
    }),
    computed: mapState({
  }),
  mounted(){

  },
  methods:{
   
  }
  }
</script>
<style scoped>
@media (max-width: 600px) {
  .mobile-nav {
    overflow-y: auto !important;
    max-height: calc(100vh - 120px) !important;
  }
}
</style>